import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    '& > *': {
      padding: theme.spacing(1)
    },
    flexGrow: 1
  },
  textField: {
    width: '100%'
  }
}));
